import { Thread } from 'APP/store/Groups/Thread';
import Entities from 'STORE';

import { loadGroupsByIds } from '../../group/loadGroupsByIds/loadGroupsByIds';

interface ILoadUnknownGroupsByIdsParams {
  groupsIds: string[];
}

export async function loadUnknownGroupsByIds({
  groupsIds,
}: ILoadUnknownGroupsByIdsParams): Promise<void> {
  const unknownGroupsIds = groupsIds.filter((groupId) => {
    const group = Entities.GroupsStore.getGroupById(groupId);
    if (!group) {
      return true;
    }

    if (group instanceof Thread) {
      return group.withoutMe && !group.isThread;
    }

    return false;
  });

  if (!unknownGroupsIds.length) {
    return;
  }

  await loadGroupsByIds(unknownGroupsIds);
}
